export function slowSlider() {
    $(".slow-slider:not(.not-slider)").each(function () {
        const slider = $(this);

        slider.slick({
            infinite: true,
            variableWidth: true,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 20000,
            cssEase: "linear",
            pauseOnHover: false,
            focusOnSelect: false
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/slow-slider.js